export default __webpack_public_path__ + "static/media/chevron-down-outline-16px.e9e325fc.svg";